import "./authInterceptor";
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./assets/css/materialdesignicons.min.css";
import LandingPage from "./pages/LandingPage";
import CreatorProgramLanding from "./pages/CreatorProgramLanding";
import CreatorLicensePage from "./pages/CreatorLicensePage";
import CreatorPrivacyPage from "./pages/CreatorPrivacyPage";
import JobsList from "./pages/jobs/JobsList";
import JobDetail from "./pages/jobs/JobDetail";
import AcademyCenter from "./pages/academy";
import StaffCenter from "./pages/staff";
import LoginPage from "./pages/login";
import MeCenter from "./pages/me";
import VerifyCertificatePage from "./pages/VerifyCertificatePage";
import "./theme.scss";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/creator" element={<CreatorProgramLanding />} />
        <Route path="/creator/license" element={<CreatorLicensePage />} />
        <Route path="/creator/privacy" element={<CreatorPrivacyPage />} />
        <Route path="/creator-program" element={<Navigate to="/creator" replace />} />
        <Route path="/jobs" element={<JobsList />} />
        <Route path="/jobs/:slug" element={<JobDetail />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/academy/*" element={<AcademyCenter />} />
        <Route path="/staff/*" element={<StaffCenter />} />
        <Route path="/me/*" element={<MeCenter />} />
        <Route path="/verify/:number" element={<VerifyCertificatePage />} />
        <Route path="/candidates" element={<Navigate to="/academy" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
